import React, { Component, useState, useEffect } from 'react';

import './styles/App.scss';
import 'bootstrap/dist/css/bootstrap.min.css';

import NavMenu from './components/NavMenu.js';

import ScrollToTop from './components/ScrollToTop.js';

import Home from './components/Home.js';
import Homepage from './components/Homepage.js';
import Schedule from './components/Schedule.js';
import WeddingParty from './components/WeddingParty.js';
import FAQ from './components/FAQ.js';
import ThingsToDo from './components/ThingsToDo.js';
import Travel from './components/Travel.js';
import Registry from './components/Registry.js';
import Pictures from './components/Pictures.js';
import RSVP from './components/RSVP.js';
import RSVPSubmit from './components/RSVPSubmit.js';
import Transportation from './components/Transportation.js';
import Admin from './components/Admin.js';
import AdminReservations from './components/AdminReservations.js';
import AdminRsvps from './components/AdminRsvps.js';
import AdminGuests from './components/AdminGuests.js';
import AdminEvents from './components/AdminEvents.js';
import Login from './components/Login.js';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {

  return (
    <Router>
      <ScrollToTop />
      <div className="App colorPrimary colorPrimaryHover backgroundColor divider navDividerTop navDividerBottom">
        <NavMenu />

        <Routes>
          <Route exact path="/" element={<Homepage/>}/>
          <Route exact path="/schedule" element={<Schedule/>}/>
          <Route exact path="/wedding-party" element={<WeddingParty/>}/>
          <Route exact path="/wedding-party/:weddingPartyID" element={<WeddingParty/>}/>

          <Route exact path="/faq" element={<FAQ/>}/>
          <Route exact path="/things-to-do" element={<ThingsToDo/>}/>
          <Route exact path="/hotel-and-travel" element={<Travel/>}/>
          <Route exact path="/travel-and-hotel" element={<Travel/>}/>
          <Route exact path="/registry" element={<Registry/>}/>
          <Route exact path="/pictures" element={<Pictures/>}/>
          <Route exact path="/transportation" element={<Transportation/>}/>
          <Route exact path="/rsvp" element={<RSVP/>}/>
          <Route exact path="/rsvp/:reservation_id" element={<RSVPSubmit/>}/>
          <Route exact path="/admin" element={<Admin/>}/>
          <Route exact path="/admin/reservations" element={<AdminReservations/>}/>
          <Route exact path="/admin/rsvps" element={<AdminRsvps/>}/>
          <Route exact path="/admin/guests" element={<AdminGuests/>}/>
          <Route exact path="/admin/events" element={<AdminEvents/>}/>
          <Route exact path="/login" element={<Login/>}/>
        </Routes>

      </div>
    </Router>
  );
}

export default App;
